/* eslint-disable no-restricted-syntax */
const config = {
  dev: { url: {} },
};

export const mapBoxToken =
  "pk.eyJ1IjoiYW1qcDIwIiwiYSI6ImNsbzJmMXlzdTF2ajAycnFvOTU0azV3NHIifQ.HS4cNjDddR_DcCKm7WAL0w";

const newConfig = {
  dev: {
    host: "https://api.dev.bizgive.app",
    media: "https://media.dev.bizgive.app/ceasset/",
    videoMedia: "https://media.dev.bizgive.app/ceassetvideo/",
    clouds3URL: "https://media.dev.bizgive.app/",
    platformURL: "https://dev.bizgive.app/#/",
  },
  qa: {
    host: "https://api.qa.bizgive.app",
    media: "https://media.qa.bizgive.app/ceasset/",
    videoMedia: "https://media.qa.bizgive.app/ceassetvideo/",
    clouds3URL: "https://media.qa.bizgive.app/",
    platformURL: "https://qa.bizgive.app/#/",
  },
  prod: {
    host: "https://api.bizgive.app",
    media: "https://media.bizgive.app/ceasset/",
    videoMedia: "https://media.bizgive.app/ceassetvideo/",
    clouds3URL: "https://media.bizgive.app/",
    platformURL: "https://www.bizgive.app/#/",
  },
  dr: {
    host: "https://api.dr.bizgive.app",
    media: "https://media.dr.bizgive.app/ceasset/",
    videoMedia: "https://media.dr.bizgive.app/ceassetvideo/",
    clouds3URL: "https://media.dr.bizgive.app/",
    platformURL: "https://www.bizgive.app/#/",
  },
  path: {
    getCeToken: "/api/ceassetpublic/getCeToken",
    getceAssets: "/api/ceasset/getceAssets",
    getCeSiteConfig: "/api/cesite/getCeSiteConfig",
    getCeEmbedToken: "/api/cesite/getCeEmbedToken",
    getAssetComponents: "/api/ceasset/getAssetComponents",
    getceQuestion: "/api/ceasset/getceQuestion",
    createVisitor: "/api/ceasset/createVisitor",
    addSubmission: "/api/ceasset/addSubmission",
    editSubmission: "/api/ceasset/editSubmission",
    getSubmissions: "/api/ceasset/getSubmissions",
    discover: "/api/program/discover",
    getProgram: "/api/program/get",
    editQAFeedback: "/api/ceasset/editQAFeedback",
    addQAFeedback: "/api/ceasset/addQAFeedback",
    getUpdate: "/api/ceasset/getUpdate",
    aiRagChat: "/api/bgai/chat",
    aiRagChat2: "/api/bgai/chat2",
    aiFaqList: "/api/bgai/faq",
    aiDocumentViewer: "/api/bgai/documents",
    aiQueries: "/api/bgai/aiQueries",
    guestRequestCode: "/api/ceasset/guest/request-code",
    guestVerifyCode: "/api/ceasset/guest/verify-code"
  },
};

const buildenv = process.env.REACT_APP_BUILD_ENV || "dev";
const { host, media, videoMedia, clouds3URL, platformURL } = newConfig[buildenv];

for (const [key, path] of Object.entries(newConfig.path)) {
  const url = `${host}${path}`;
  config.dev.url[key] = url;
  config.dev.url.imageURL = media;
  config.dev.url.videoURL = videoMedia;
  config.dev.url.clouds3URL = clouds3URL;
  config.dev.url.baseURL = platformURL;
}

export default config;
